<div class="row">
  <div class="fulfillmentLanding create-return-outer" (window:resize)="onresize($event)">
    <div class="create-return-page">
      <div class="page-head xs-mt-15">
        <h3 class="d-flex align-items-center">Seed Returns <i [ngClass]="{'all-icon': (selectedProductLineText == 'All'), 'corn-icon': (selectedProductLineText == 'Corn'), 'alfa-icon': (selectedProductLineText == 'Alfalfa'), 'cotton-icon': (selectedProductLineText == 'Cotton'), 'canola-icon': (selectedProductLineText == 'Spring Canola' || selectedProductLineText == 'Winter Canola'),  'sorghum-icon': (selectedProductLineText == 'Forage Sorghum' || selectedProductLineText == 'Grain Sorghum' ), 'sunflower-icon': (selectedProductLineText == 'Sunflower')}" class="xs-ml-10 xs-mr-10 light-weight"></i><span>{{selectedProductLineText}}</span></h3>
      </div>
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" routerLink="/seed-returns-dashboard/{{seedReturnService.dashboardSelectedProductLine}}">Seed Return</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>{{selectedProductLineText}}</span>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="returnTop xs-mb-5">
        <!--Ship to - Confirmation Email Section-->
        <div>
          <div class="row">
            <div class="col-md-3 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         placeholder="Account:"
                         [closeOnSelect]="true"
                         [disabled]="true">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div>
                          Account #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-lg-3 col-md-6 xs-mb-15">
              <label>SDM:</label>
              <div>
                {{dsmInfo}}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 xs-mb-15">
              <label *ngIf="isShowNonSubEmail">Non-Subscriber Email:</label>
              <label *ngIf="!isShowNonSubEmail">Email:</label>
              <div>
                {{accountEmail}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="returnTop xs-mb-5">
        <div class="row">
          <div class="col-md-4">
            <span class="font-16">
              I have product(s) to return:*
            </span>
            <span class="d-inline-block">
              <mat-radio-group class="example-radio-group" [disabled]="true">
                Yes <mat-radio-button class="custom-radio" value="true" [checked]="rdProduct"></mat-radio-button>
                No <mat-radio-button class="custom-radio" value="false" [checked]="rdProduct===false"></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
          <div class="col-md-4" *ngIf="emptyPallet === 'Y'">
            <span class="font-16">
              I have empty pallet(s) to return:{{mandatoryFieldSymbol}}
            </span>
            <span class="d-inline-block">
              <mat-radio-group class="example-radio-group" [disabled]="true">
                Yes <mat-radio-button class="custom-radio" value="true" [checked]="rdEmptyPallet"></mat-radio-button>
                No <mat-radio-button class="custom-radio" value="false" [checked]="rdEmptyPallet===false"></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
          <div class="col-md-4" *ngIf="emptyCBox === 'Y'">
            <span class="font-16">
              I have empty CBox(s) to return:{{mandatoryFieldSymbol}}
            </span>
            <span class="d-inline-block">
              <mat-radio-group class="example-radio-group" [disabled]="true">
                Yes <mat-radio-button class="custom-radio" value="true" [checked]="rdEmptyCBox"></mat-radio-button>
                No <mat-radio-button class="custom-radio" value="false" [checked]="rdEmptyCBox===false"></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
        </div>
      </div>

      <!--Pickup Information Section-->
      <div class="returnTop xs-mb-0" *ngIf="isShowPickInfo">
        <h6 class="form-group-title">Pickup Information:</h6>
        <div class="row">
          <div class="col-lg-2 col-md-6 xs-mb-15">
            <label>Desired Pickup Date:</label>
            <div>
              {{desiredPickupDate | date:'MM/dd/yyyy'}}
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="xs-mb-15">
              <label>Contact Name:</label>
              <div>
                {{contactName}}
              </div>
            </div>
            <div class="xs-mb-15">
              <label>Contact Number:</label>
              <div>
                {{contactNumber | mask: '000-000-0000' }}
              </div>
            </div>
            <div class="xs-mb-15">
              <label>Customer PO Number:</label>
              <div>
                {{customerPONumber}}
              </div>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr">
            <div class="xs-mb-15">
              <label>Pickup Location:</label>
              <div>
                {{deliveryAccountName}}
              </div>
            </div>
            <div class="xs-mb-15">
              <label>Shipping Instructions:</label>
              <div>
                {{shippingInstructions}}
              </div>
            </div>
          </div>
          <div class=" col-lg-4 col-md-6 material-select withBordr">
            <div class="xs-mb-15">
              <label>Freight Instructions:</label>
              <div class="h-50">
                {{selectedFreightInstructionName}}
              </div>
            </div>
            <div class="row no-gutter">
              <div class="col-md-4 xs-mb-15 xs-pl-15" *ngIf="rdProduct">
                <label>Pallet Count:</label>
                <div>
                  {{palletCount}}
                </div>
              </div>
              <div class="col-md-4 xs-mb-15 xs-pl-10 xs-pr-10" *ngIf="rdEmptyPallet">
                <label>Empty Pallet Count:</label>
                <div>
                  {{emptyPalletCount}}
                </div>
              </div>
              <div class="col-md-4 xs-mb-15 xs-pr-15" *ngIf="rdEmptyCBox">
                <label>Empty CBox Count:</label>
                <div>
                  {{emptyBoxCount}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngFor="let products of splitDataSource">
        <div class="returnDetail" *ngIf="rdProduct">
          <!--Product Detail section-->
          <div class="addProdContent">
            <div class="row">
              <div class="col-md-12 margin-t10">
                <div class="productTableOuter">
                  <div class="alignInOrder">
                    <span class="requestID">Request ID: {{returnRequestNumber}}-{{products.splitId}} </span>
                    <span *ngIf="isShowOrderNumber(products)" class="order-number">Order Number: {{products.jdeOrderNumber}}</span>
                    <span *ngIf="!isShowOrderNumber(products)" class="order-number"></span>
                    <div class="pallet">
                      <span class="pallet-count padding-r15">Pallet Count: {{products.splitStockPalletCount}} </span>
                      <span class="empty-pallet padding-r15" *ngIf="rdEmptyPallet">Empty Pallet Count: {{products.splitEmptyStockPalletCount}} </span>
                      <span class="empty-pallet" *ngIf="rdEmptyCBox">Empty CBox Count: {{products.splitEmptyCboxCount}} </span>
                    </div>
                  </div>
                  <div class="tableContainer prodTableContainer" id="returnRequestView">
                    <table mat-table [dataSource]="products.productDetail" multiTemplateDataRows class="matTables productTable">
                      <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                        <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                  </div>
                  <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
                  <div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Item Number</th></div>
                  <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot Number</th></div>
                  <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
                  <div *ngIf="column=='units'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
                  <div *ngIf="column=='dumpedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Requested Units</th></div>
                  <div *ngIf="column=='notes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
                  <td mat-cell *matCellDef="let element">
                    <div *ngIf="column=='product'" class="order-info-outer">
                      <div class="order-info">
                        <p class="prod-id">{{element.itemVendorName}}</p>
                        <p class="prod-name">{{element.itemDescription}}</p>
                      </div>
                    </div>
                    <div *ngIf="column=='itemNumber'" class="measureUnit text-center">
                      <p> {{element.itemNumber}} </p>
                    </div>
                    <div *ngIf="column=='lotNumber'" class="measureUnit text-center">
                      <p> {{element.lotNumber}} </p>
                    </div>
                    <div *ngIf="column=='uom'" class="measureUnit text-center">
                      <p> {{element.uom}} </p>
                    </div>
                    <div *ngIf="column=='units'" class="measureUnit text-center">
                      <p> {{element.eligibleUnit}} </p>
                    </div>
                    <div *ngIf="column=='dumpedUnits'" class="measureUnit text-center">
                      <p> {{element.returnQuantity}} </p>
                    </div>
                    <div *ngIf="column=='notes'" class="measureUnit text-center">
                      <p> {{element.requestorNotes}} </p>
                    </div>
                  </td>
                  </ng-container>

                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                  <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                      class="example-element-row"
                      [class.example-expanded-row]="expandedElement === element"></tr>
                  </table>
                  <div *ngIf="products.productDetail == undefined || products.productDetail?.length == 0" class="noDataMsg non-product">
                    <p>Non Product Order</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row padding-10 margin-b10 no-gutters contract-info">
      <div class="text-center text-md-left xs-mb-20 md-mb-0 col-md-2 padding-l0 pdfText">
        <span class="md-ml-15 round-icon xs-mr-35 md-mr-15 mobile-round" (click)="generatedPdf()">
          <i class="far fa-file-pdf"></i>
        </span>
        View PDF to Print
      </div>
    </div>

    <div class="SeedFulfillBtnSec">
      <div class="row padding-l20">
        <div class="col-11 text-right">
          <span class="count">Returnable Products <span>{{totalProductCount}}</span></span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
